export const NAVIGATION_COLORS = {
    WORKLIST_BG: '#2C3E47',
    QA_BG: '#203D48',
    TEXT_PRIMARY: '#FFFFFF',
    TEXT_SELECTED: '#E5927D',
    SELECTED_BG: 'rgba(229, 146, 125, 0.15)',
    HOVER_BG: 'rgba(255, 255, 255, 0.04)',
    TEXT_LOW: '#8CB4C2',
    TOGGLE_BG: '#5E8A93',
    TOGGLE_HOVER: '#4F7B84',
};

export const STORAGE_KEYS = {
    WORKLIST_SIDEBAR: 'worklistSidebarVisible',
    QA_SIDEBAR: 'qaSidebarVisible',
    QA_EXPANDED_SECTION: 'projectSelectColumn_expandedSection',
};

export const NAVIGATION_WIDTH = '250px';
export const COLLAPSED_WIDTH = '32px';

export const SEARCH_PLACEHOLDERS = {
    WORKLIST: 'Search views...',
    QA: 'Search projects...',
};
